<div [ngClass]="isCustomUiChange ? 'loader-container' : 'spinner-center'" *ngIf="searching">
  <mat-spinner [diameter]="80" color="primary"></mat-spinner>
</div>
<div [ngClass]="isCustomUiChange ? 'offices-container' : ''" [hidden]="searching">
  <mat-card [ngClass]="isCustomUiChange ? 'offices-card' : 'user-card'">
    <mat-card-header *ngIf="!isCustomUiChange">
      <mat-card-title class="office-title">
        <span matBadge="{{ offices.length }}" matBadgeOverlap="false">Offices</span>
      </mat-card-title>
      <div class="office-header-actions">
        <button mat-button (click)="addNewOffice()" class="btn-add-office">
          <mat-icon matTooltip="Add Office" aria-hidden="false" color="primary" class="add-icon">
            add
          </mat-icon>
        </button>
      </div>
    </mat-card-header>

    <!-- new CSS chages apply for FEMD and DOM1 -->
    <mat-card-header *ngIf="isCustomUiChange" class="offices-header">
      <mat-card-title class="offices-title">
        <span matBadge="{{ offices.length }}" matBadgeOverlap="false">Offices</span>
      </mat-card-title>

      <!-- Search Bar -->
      <mat-form-field appearance="outline" class="offices-search-field">
        <mat-label>Search</mat-label>
        <input matInput [(ngModel)]="searchValue" (ngModelChange)="applyFilter()" placeholder="Search offices..."
          autocomplete="off" />
        <button mat-icon-button matSuffix *ngIf="searchValue" (click)="clearSearch()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <button mat-icon-button class="add-office-btn" (click)="addNewOffice()">
        <mat-icon matTooltip="Add Office" color="primary">add</mat-icon>
      </button>
    </mat-card-header>
    <mat-divider></mat-divider>

    <mat-card-content [ngClass]="isCustomUiChange ? 'offices-table-section' : ''">
      <br *ngIf="!isCustomUiChange">
      <table mat-table [dataSource]="dataSource" [ngClass]="isCustomUiChange ? 'offices-table' : ''"
        class="mat-elevation-z8" matSort>

        <ng-container matColumnDef="OfficeId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Office ID</th>
          <td mat-cell *matCellDef="let off" matTooltip="{{off.OfficeId}}"> {{ off.OfficeId }} </td>
        </ng-container>

        <ng-container matColumnDef="OfficeDescription">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
          <td mat-cell *matCellDef="let off" matTooltip="{{off.OfficeDescription}}"> {{off.OfficeDescription}} </td>
        </ng-container>

        <ng-container matColumnDef="ProgramSponsorId">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>ProgramSponsor</th>
          <td mat-cell *matCellDef="let off" matTooltip="{{off.ProgramSponsor.ProgramSponsorDescription}}">
            {{off.ProgramSponsor.ProgramSponsorDescription}} </td>
        </ng-container>


        <ng-container matColumnDef="OfficeActive">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Active</th>
          <td mat-cell *matCellDef="let off">
            <mat-icon matTooltip="Check" *ngIf="off.OfficeActive" color="primary">check_box</mat-icon>
            <mat-icon matTooltip="Cancel" *ngIf="!off.OfficeActive" class="icon-cancel">cancel</mat-icon>
          </td>
        </ng-container>

        <ng-container matColumnDef="CreatedDate">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Created Date</th>
          <td mat-cell *matCellDef="let off"> {{off.CreatedDate | date:'shortDate' }} </td>
        </ng-container>


        <ng-container matColumnDef="ModifiedBy">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="modify-office">ModifiedBy</th>
          <td mat-cell *matCellDef="let off" matTooltip="{{off.ModifiedBy}}"> {{off.ModifiedBy }} </td>
        </ng-container>


        <ng-container matColumnDef="edit" stickyEnd>
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="empty-header"></th>
          <td mat-cell *matCellDef="let off">
            <button mat-button (click)="handleClick(off)" matTooltip="Create">
              <mat-icon matTooltip="Edit" color="primary">create</mat-icon>
            </button>

          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
      <mat-paginator [pageSizeOptions]="[5,10,20]" showFirstLastButtons></mat-paginator>
    </mat-card-content>
  </mat-card>
</div>